import "./Layout.scss";
import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FaGreaterThan, FaLessThan, FaUser } from "react-icons/fa";
import { CiMenuBurger } from "react-icons/ci";
import { TfiReload } from "react-icons/tfi";
import UserProfile from "./UserProfile";
import { ImCross } from "react-icons/im";
import { MdDashboard, MdReport } from "react-icons/md";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { INSERT_ACCESS } from "../../_contstants/common";
import { RiNumbersLine } from "react-icons/ri";
import { IoMdSettings } from "react-icons/io";

export const menuData = [
  {
    key: "dashboard",
    title: "Dashboard",
    icon: <MdDashboard />,
    quickMenu: [],
    sections: [],
  },
  {
    key: "usermanagement",
    title: "User Management",
    icon: <FaUser />,
    quickMenu: [
      { title: "Menu", key: "menu" },
      { title: "Rights", key: "rights" },
      { title: "User", key: "user" },
      { title: "User Type", key: "usertype" },
    ],
    sections: [],
  },
  {
    key: "masters",
    title: "Masters",
    icon: <IoMdSettings />,
    quickMenu: [],
    sections: [
      {
        title: "Place",
        children: [
          {
            title: "Country",
            key: "country",
          },
          {
            title: "State",
            key: "state",
          },
          {
            title: "City",
            key: "city",
          },
        ],
      },
      {
        title: "Generals",
        children: [
          {
            title: "Charges",
            key: "charges",
          },
          { title: "Product Category", key: "itemcategory" },
          { title: "Product Sub Category", key: "productsubcategory" },
          { title: "Product", key: "item" },
          { title: "Process", key: "process" },
          { title: "Priority", key: "priority" },
          { title: "Vepari", key: "party" },
          { title: "Karigar", key: "karigar" },
          { title: "Purity", key: "purity" },
          { title: "Unit", key: "unit" },
        ],
      },
    ],
  },
  {
    key: "OrderMenu",
    title: "Orders",
    icon: <RiNumbersLine />,
    quickMenu: [{ title: "Add Order", key: "order/create" }],
    sections: [
      {
        title: "General",
        children: [
          { title: "Order", key: "order" },
          { title: "Part Addto Orders", key: "partaddtoorders" },
          { title: "Purchase Entry", key: "purchaseentry" },
          { title: "Order Labeling", key: "orderlabeling" },
          { title: "Split Item", key: "splititem" },
        ],
      },
    ],
  },
  {
    key: "ProcessMenu",
    title: "Process",
    icon: <TfiReload />,
    quickMenu: [
      { title: "Add Ghat Issue", key: "ghatissue/create" },
      { title: "Add Ghat Receipt", key: "ghatissuereceipt/create" },
      { title: "Add Palish Issue", key: "palish/create" },
      { title: "Add Palish Receipt", key: "palishreceipt/create" },
      { title: "Add Dull Issue", key: "dull/create" },
      { title: "Add Dull Receipt", key: "dullreceipt/create" },
      { title: "Add Mina Issue", key: "mina/create" },
      { title: "Add Mina Receipt", key: "minareceipt/create" },
      { title: "Add Jadai Issue", key: "jadai/create" },
      { title: "Add Jadai Receipt", key: "jadaireceipt/create" },
      { title: "Add Bandhai Issue", key: "bandhai/create" },
      { title: "Add Bandhai Receipt", key: "bandhaireceipt/create" },
    ],
    sections: [
      {
        title: "Issue",
        children: [
          { title: "Ghat Issue", key: "ghatissue" },
          { title: "Palish Issue", key: "palish" },
          { title: "Dull Issue", key: "dull" },
          { title: "Mina Issue", key: "mina" },
          { title: "Jadai Issue", key: "jadai" },
          { title: "Bandhai Issue", key: "bandhai" },
        ],
      },
      {
        title: "Receipt",
        children: [
          { title: "Ghat Receipt", key: "ghatissuereceipt" },
          { title: "Palish Receipt", key: "palishreceipt" },
          { title: "Dull Receipt", key: "dullreceipt" },
          { title: "Mina Receipt", key: "minareceipt" },
          { title: "Jadai Receipt", key: "jadaireceipt" },
          { title: "Bandhai Receipt", key: "bandhaireceipt" },
          { title: "Payment Receipt", key: "paymentreceipt" },
        ],
      },
      {
        title: "General",
        children: [
          { title: "Bandhai Settlement Form", key: "bandhaisettlementform" },
        ],
      },
    ],
  },
  {
    key: "Reportsmenu",
    title: "Reports",
    icon: <MdReport />,
    quickMenu: [{ title: "Add Order", key: "order/create" }],
    sections: [
      {
        title: "General",
        children: [
          {
            title: "Stock Report",
            key: "stockreport",
          },
        ],
      },
      {
        title: "Issue Reports",
        children: [
          {
            title: "Ghat Issue Pending Order Report",
            key: "ghat-issue-pending-order-report",
          },
          {
            title: "Palish Issue Pending Order Report",
            key: "palish-issue-pending-order-report",
          },
          {
            title: "Dull Issue Pending Order Report",
            key: "dull-issue-pending-order-report",
          },
          {
            title: "Mina Issue Pending Order Report",
            key: "mina-issue-pending-order-report",
          },
          {
            title: "Jadai Issue Pending Order Report",
            key: "jadai-issue-pending-order-report",
          },
          {
            title: "Bandhai Issue Pending Order Report",
            key: "bandhai-issue-pending-order-report",
          },
        ],
      },
      {
        title: "Ledger Reports",
        children: [
          // {
          //   title: "Karigar Phine (gm) Ledger Report",
          //   key: "karigar-phine-ledger-report",
          // },
          // {
          //   title: "Karigar Amount Ledger Report",
          //   key: "karigar-amount-ledger-report",
          // },
          {
            title: "Ghat Karigar Ledger Report",
            key: "ghat-karigar-ledger-report",
          },
          {
            title: "Bandhai Karigar Ledger Report",
            key: "bandhai-karigar-ledger-report",
          },
          {
            title: "Jadai Karigar Ledger Report",
            key: "jadai-karigar-ledger-report",
          },
          {
            title: "Palish Karigar Ledger Report",
            key: "palish-karigar-ledger-report",
          },
          {
            title: "Dull Karigar Ledger Report",
            key: "dull-karigar-ledger-report",
          },
          {
            title: "Mina Karigar Ledger Report",
            key: "mina-karigar-ledger-report",
          },
        ],
      },
    ],
  },
];

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userRights: {
    menu_id: number;
    menu_key: string;
    menu_name: string;
    rights_id: string;
  }[];

  try {
    userRights = JSON.parse(userResponseString);
  } catch (error) {
    userRights = [];
  }

  const filterMenuByUserRights = (menuData: any, userRights: any) => {
    const hasRight = (key: string) => {
      if (key.includes("/create")) {
        const baseKey = key.replace("/create", "");
        const userMenu = userRights?.find(
          (menu: any) => menu.menu_key === baseKey,
        );
        return (
          userMenu && userMenu.rights_id.split(", ").includes(INSERT_ACCESS)
        );
      } else {
        return userRights?.some((menu: any) => menu.menu_key === key);
      }
    };

    return menuData
      .map((menu: any) => {
        const mainMenuHasRight = hasRight(menu.key);

        if (!mainMenuHasRight) return null;

        const filteredQuickMenu = menu.quickMenu.filter((item: any) =>
          hasRight(item.key),
        );
        const filteredSections = menu.sections
          .map((section: any) => {
            const filteredChildren = section.children.filter((child: any) =>
              hasRight(child.key),
            );
            return { ...section, children: filteredChildren };
          })
          .filter((section: any) => section.children.length > 0);
        if (
          hasRight(menu.key) ||
          filteredQuickMenu.length > 0 ||
          filteredSections.length > 0
        ) {
          return {
            ...menu,
            quickMenu: filteredQuickMenu,
            sections: filteredSections,
          };
        }
        return null;
      })
      .filter((menu: any) => menu !== null);
  };

  const filteredMenus = filterMenuByUserRights(menuData, userRights);
  // {
  //   false && console.log(filteredMenus);
  // }

  const toggleMenu = () => {
    document.querySelectorAll(".navbar-nav > li").forEach((element) => {
      element.addEventListener("click", function (this: HTMLElement) {
        document.querySelector(".page-contect")?.classList.remove("in");
        document.querySelectorAll(".navbar-nav > li").forEach((li) => {
          li.classList.remove("active");
          const popup = document.querySelector(
            ".navbar-nav > li.active .subnav-content",
          );
          if (popup) {
            const popupElement = popup as HTMLElement;
            popupElement.classList.remove("d-block");
            popupElement.classList.add("d-none");
          }
        });
        this.classList.add("active");
        const popup = document.querySelector(
          ".navbar-nav > li.active .subnav-content",
        );
        if (popup) {
          const popupElement = popup as HTMLElement;
          popupElement.classList.remove("d-none");
          popupElement.classList.add("d-block");
        }
      });
    });
  };

  useEffect(() => {
    toggleMenu();
  }, []);

  const toggleSubMenu = () => {
    const popup = document.querySelector(
      ".navbar-nav > li.active .subnav-content",
    );
    if (popup) {
      const popupElement = popup as HTMLElement;
      popupElement.classList.remove("d-block");
      popupElement.classList.add("d-none");
    }

    document.querySelectorAll(".navbar-nav > li").forEach((li) => {
      li.classList.remove("active");
    });
  };

  const toggleNav = () => {
    const sidenav = document.querySelector(".side-nav") as any;
    const mbottom = document.querySelector(".m-bottom") as any;
    const ainavbarheader = document.querySelector(".ainavbar-header") as any;
    const pagewrapper =
      document.querySelector(".page-wrapper") ||
      (document.querySelector(".dashboard-page-wrapper") as any);
    const pagecontect = document.querySelectorAll(".page-contect") as any;
    const menuName = document.querySelectorAll(".menu-name") as any;
    const greaterThan = document.querySelector(".greaterthan") as any;
    const lessThan = document.querySelector(".lessthan") as any;
    // const headerTitle = document.querySelector(".header-title") as any;

    const isOpen = sidenav.style.width === "210px";
    const isHeaderOpen = ainavbarheader.style.width === "210px";
    // headerTitle.style.setProperty("--content", isOpen ? '"AI"' : '"AICRM"');
    sidenav.style.width = isOpen ? "60px" : "210px";
    mbottom.style.width = isOpen ? "60px" : "210px";
    pagewrapper.style.marginLeft = isOpen ? "60px" : "210px";
    ainavbarheader.style.width = isHeaderOpen ? "60px" : "210px";
    pagecontect.forEach((element: any) => {
      if (isOpen) {
        element.style.left = "60px";
      } else {
        element.style.left = "210px";
      }
    });
    menuName.forEach((element: any) => {
      if (isOpen) {
        element.style.transition = "0.5s";
        element.classList.remove("d-inline");
        element.classList.add("d-none");
      } else {
        element.style.transition = "0.5s";
        element.classList.remove("d-none");
        element.classList.add("d-inline");
      }
    });
    if (isOpen) {
      lessThan.classList.remove("d-block");
      lessThan.classList.add("d-none");
      greaterThan.classList.remove("d-none");
      greaterThan.classList.add("d-block");
    } else {
      lessThan.classList.remove("d-none");
      lessThan.classList.add("d-block");
      greaterThan.classList.remove("d-block");
      greaterThan.classList.add("d-none");
    }
  };

  // const handleNavigate = (url: string) => {
  //   if (url) {
  //     toggleSubMenu();
  //     navigate(`${url}`);
  //   }
  // };

  const handleNavigate = (e: React.MouseEvent, url: string) => {
    if (!url) return;
    // Check if Ctrl or Meta (Cmd on Mac) key was pressed
    if (e.ctrlKey || e.metaKey) {
      // Open in new tab
      window.open(`${url}`, "_blank");
    } else {
      // Normal navigation
      toggleSubMenu();
      navigate(`${url}`);
    }
    // Prevent default to avoid any potential conflicts
    e.preventDefault();
  };

  return (
    <>
      <div id="wrapper">
        <nav className="ainavbar" role="navigation">
          <div className="ainavbar-header" style={{ width: 210 }}>
            <button type="button" className="navbar-toggle">
              <CiMenuBurger />
            </button>
            <h3 className="m-0 header-title">HK</h3>
          </div>
          <div className="d-flex align-items-center">
            <UserProfile />
          </div>
        </nav>
        <div className="collapse navbar-collapse navbar-ex1-collapse show">
          <ul
            className="nav navbar-nav side-nav"
            style={{ zIndex: 10, scrollbarWidth: "none", width: 210 }}
          >
            {filteredMenus.map((menu: any, index: any) => {
              return (
                <li
                  className="subnav"
                  key={index}
                  onClick={toggleMenu}
                  style={{
                    marginBottom: filteredMenus?.length - 1 === index ? 55 : 0,
                  }}
                >
                  <p
                    className="collapsed"
                    onClick={() =>
                      menu.key === "dashboard"
                        ? navigate("/")
                        : menu.quickMenu?.length < 1 &&
                            menu.sections?.length < 1
                          ? navigate(`/${menu?.key}`)
                          : null
                    }
                  >
                    <Tooltip
                      anchorElement="target"
                      position="right"
                      parentTitle={true}
                    >
                      <span title={menu.title} className="m-0">
                        {menu.icon}
                        <span className="menu-name">{menu.title || ""}</span>
                      </span>
                    </Tooltip>
                  </p>
                  {(menu.quickMenu?.length > 0 ||
                    menu.sections?.length > 0) && (
                    <div className="subnav-content page-contect">
                      <div className="container-fluid">
                        <div className="container-title">
                          <h2 className="fw-600">{menu.title} - Quick Menu</h2>
                          <button
                            className="model-close"
                            onClick={toggleSubMenu}
                          >
                            <ImCross />
                          </button>
                        </div>
                        {menu.quickMenu?.length > 0 && (
                          <div className="quick-menu">
                            <div className="quick-menu-cards">
                              {menu.quickMenu.map((item: any) => (
                                <div
                                  key={item.key}
                                  className="quick-menu-card"
                                  onClick={(e) => handleNavigate(e, item.key)}
                                >
                                  <h5>{item.title}</h5>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        <div className="section-list">
                          {menu.sections?.map(
                            (section: any) =>
                              section.children?.length > 0 && (
                                <div key={section.title} className="section">
                                  <h4>{section.title}</h4>
                                  <ul>
                                    {section.children.map((child: any) => (
                                      <Tooltip
                                        key={child.key}
                                        anchorElement="target"
                                        position="top"
                                        parentTitle={true}
                                      >
                                        <li
                                          key={child.key}
                                          title={child.title}
                                          onClick={(e) =>
                                            handleNavigate(e, child.key)
                                          }
                                        >
                                          {child.title}
                                        </li>
                                      </Tooltip>
                                    ))}
                                  </ul>
                                </div>
                              ),
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
            <div className="m-bottom" onClick={toggleNav}>
              <span className="m-arrow">
                <FaGreaterThan className="greaterthan d-none cursor-pointer" />
                <FaLessThan className="lessthan cursor-pointer" />
              </span>
            </div>
          </ul>
        </div>
        {location.pathname === "/" ? (
          <div className="all-page">
            <div className="dashboard-page-wrapper">
              <Outlet />
            </div>
          </div>
        ) : (
          <div className="all-page">
            <div className="page-wrapper">
              <div className="page-information ">
                <Outlet />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Layout;
